<template>
	<article v-show="isShow_tuwen" 
	:class="{
		'tuwen-mask-PC': !$store.state.isMobile,
		'tuwen-mask-Moblie': $store.state.isMobile
	}">
		<!-- 查看大图功能 -->
		<section  v-if="largeImg" @click="switchLargeImg('close')" class="largeImg-bg flex center">
			<img class="largeImg-icon" :src="largeImg" alt="">
		</section>
		<!-- 查看大图功能 -->
		
		<!-- 查看图文页 -->
		<swiper class="tuwen-list" ref="mySwiper" :options="swiperOptions">
			<swiper-slide class="tuwen-item"			
			v-for="(item,index) in bannerList" :key="index"
			:class= "{
				'tuwen-item-1': item.type === 'step',
				'tuwen-item-2': item.type !== 'step'
			}">
			 <img @click="switchGra('close')" class="close-icon" src="../../../assets/robot/close.png" alt="">
			  
			  <!-- 步骤页 -->
			  <article v-if="item.type === 'step'" class="stepPage">
				<section class="phone">
					<img class="phone-head" src="../../../assets/robot/phone-head.png" alt="">
					<img class="phone-body" src="../../../assets/robot/phone-body-null.png" alt="">
					<img @click="switchLargeImg('open',item.image)" class="phone-content" :src="item.image" alt="">
				</section>
				<div class="tips" @click="switchLargeImg('open',item.image)">点击查看大图</div>
				<div class="note">{{item.details}}</div>
			  </article>
			  <!-- 步骤页 -->
			  
			  <!-- 反馈页 -->
			  <article v-if="item.type === 'feedback'"  class="feedbackPage">
				<section class="endPage-say">
					<section class="endPage-say-t">
						<div class="endPage-say-txt flex center">{{feedBacklist[feedBackStatus].txt}}</div>
						<div class="endPage-evaluate flex between">
							<section>
								<img class="endPage-evaluate-icon" v-if="feedBackStatus === 1" src="../../../assets/robot/fd-up-active.png"  alt="">
								<img class="endPage-evaluate-icon" @click="feedback('good')"  v-else src="../../../assets/robot/fd-up.png" alt="">
							</section>
							<section>
								<img class="endPage-evaluate-icon" v-if="feedBackStatus === 2" src="../../../assets/robot/fd-down-active.png" alt="">
								<img class="endPage-evaluate-icon" @click="feedback('bad')" v-else  src="../../../assets/robot/fd-down.png" alt="">
							</section>
						</div>
					</section>
					<div class="endPage-say-b"></div>
				</section>
				
				<img class="endPage-icon" :src="feedBacklist[feedBackStatus].icon" alt="">
			  </article>
			  <!-- 反馈页 -->
			  
			  <!-- 结束页 -->
			  <article v-if="item.type === 'end'"  class="endPage">
				<img class="sucess-icon" src="../../../assets/robot/feedback-success.png" alt="">
				<div class="sucess-txt">提交成功</div>
				<section class="sayBox">
					<div class="sayBox-t flex center">我们会继续努力做好~</div>
					<div class="sayBox-b"></div>
				</section>
				<img class="endPage-icon" src="../../../assets/robot/giveThumbs.png" alt="">
			  </article>
			  <!-- 结束页 -->

			</swiper-slide>	 
			<div class="swiper-pagination" slot="pagination"></div>
			<div class="swiper-button-prev" slot="button-prev"></div>
			<div class="swiper-button-next" slot="button-next"></div>
		</swiper>
		<!-- 查看图文页 -->

		<!-- 反馈 -->
		<article v-if="isShow_feedback" class="feedback">
			<section class="feedback-H">
				<img class="feedback-H-icon" src="../../../assets/robot/feed-edit.png" mode=""/>
				<span class="feedback-H-txt">意见反馈</span>
			</section>
			<section class="feedback-C ">
				<section class="feedback-C-t flex between">
					<div class="feedback-C-t-i flex center"
					:class="{'feedback-C-i-active': selectReasonIndex === reasonIndex }"
					v-for="(reasonItem,reasonIndex) in reason" :key="reasonIndex"
					@click="reasonChange(reasonIndex)">{{reasonItem}}</div>
				</section>
				<section class="feedback-C-b">
					<textarea maxlength="100"
					v-model="content" placeholder="选填"/>
					<div class="feedback-num">
						<span>{{content.length}}</span>
						<span>/100</span>
					</div>
				</section>
			</section>
			<section class="feedback-F flex center" @click="submitFeedBack()">提交</section>
		</article>
		<!-- 反馈 -->
		
	</article>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import util from  "../../../util/util.js"
import 'swiper/css/swiper.css'

export default {
  name: 'carrousel',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
		largeImg: null,
		isShow_tuwen: false,
		isShow_feedback: false,
		selectReasonIndex: -1,
		fankui_id: "",
		title: "",
		content: "",
		pid: "",
		cityname: "上海",
		standardQ: "",
		
		bannerList: [],
		currentIndex: 0,
		feedBacklist: [
			{
				txt: "到此已经全部完成啦，对您是否有帮助呢？",
				icon: require("../../../assets/robot/back.png"),
			},
			{
				txt: "感谢您的点赞，您的鼓励是我前进最大的动力~",
				icon: require("../../../assets/robot/giveThumbs.png"),
			},
			{
				txt: "给您带来不好的体验，我会继续改进， 下次为您提供更好的服务。",
				icon: require("../../../assets/robot/failback.png"),
			}
		],
		reason: ["不是我想要的答案","内容看不懂","答案方法不可行"],
		feedBackStatus: 0,
		swiperOptions: {
			// direction: 'vertical', // 竖向滚动
			autoHeight: true, // 自适应高度
			autoplay: {
			  delay: 100000,
			  stopOnLastSlide: false,
			  disableOnInteraction: false
			},
			observer: true,
			// 显示分页
			pagination: {
			  el: '.swiper-pagination',
			  clickable: true // 允许分页点击跳转
			},
			// 设置点击箭头
			navigation: {
			  nextEl: '.swiper-button-next',
			  prevEl: '.swiper-button-prev'
			}
		}
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  mounted() {
	// console.log('Current Swiper instance object', this.swiper)
  },
  props: {
	graphicData: Object
  },
  watch: {
	isShow_tuwen: {
		handler(newVal,oldVal) {
			if (newVal) {
				this.swiper.slideTo(0);
				this.cityname = this.$props.graphicData.cityname;
				this.pid = this.$props.graphicData.pid;
				this.user_input = this.$props.graphicData.user_input;
				this.standardQ = this.$props.graphicData.standardQ; 
				this.feedBackStatus	= this.$props.graphicData.tuwenStatus;
				this.bannerList = this.$props.graphicData.content;
				if (!this.bannerList[0].hasOwnProperty("type")) {
					this.bannerList.forEach( i=> {i.type = "step"});
					this.bannerList.push({type: "feedback"});
				}
			} else {
				this.$emit("closeTuwen",{feedBackStatus: this.feedBackStatus, content: this.bannerList })
				this.bannerList = [];
			}
		},
		immediate: true,
		deep: true
	},
  },
  methods:{
		switchLargeImg(type,img) {
			type === 'open'
				? this.largeImg = img
				: this.largeImg = null
		},
		switchGra(type) {
			if (type === 'open') {
				this.isShow_tuwen = true;
			} else {
				this.isShow_tuwen = false;
			}
		},
		/**
		* 反馈
		* @method feedback
		*/
		async feedback(type) {
			if (this.feedBackStatus === 0) {
				if (type === "good") {
					let data = {
						action: "fankui",
						title: this.standardQ,
						pid: this.pid,
						graphic_res: "满意",
						cityname: this.cityname,
						user_input: this.user_input,
						platform: "h5"
					};
					let res = await util.request(data);
					this.fankui_id = res.data.data.id;
					this.$emit("saveChatlist",this.fankui_id );
					this.feedBackStatus = 1;
				} else {
					
					let data = {
						action: "fankui",
						title: this.standardQ,
						pid: this.pid,
						graphic_res: "不满意",
						cityname: this.cityname,
						user_input: this.user_input,
						platform: "h5"
					};
					let res = await util.request(data);
					this.fankui_id = res.data.data.id; 
					this.$emit("saveChatlist",this.fankui_id );
					console.log(this.fankui_id);
					this.isShow_feedback = true;
					this.feedBackStatus = 2;
				}
			}
		},
		/**
		* 改变理由
		* @method reasonChange
		*/
		reasonChange(reasonIndex) {
			this.selectReasonIndex = reasonIndex;
			this.title = this.reason[reasonIndex] 
		},
		/**
		* 提交反馈
		* @method submitFeedBack
		*/
		async submitFeedBack() {
			try {
				let data = {
					action: "fankui_text",
					type: "tuwen",
					fankui_id: this.fankui_id,
					title: this.title,
					content: this.content,
					cityname: this.cityname,
					platform: "h5"
				};
				let res = await util.request(data);
				this.isShow_feedback = false;
				this.bannerList.pop();
				this.bannerList.push({type: "end"});
			} catch (e) {
				this.isShow_feedback = false;
				this.bannerList.pop();
				this.bannerList.push({type: "end"});
			}
		},
		/**
		* 获取图文数据
		* @method getTuwen
		*/
		// async getTuwen() {
		// 	let data = {
		// 		action: "reply",
		// 		keywords: this.user_input,
		// 		cityname: this.cityname
		// 	}
		// 	let res = await util.request(data);
		// 	this.bannerList = res.data.data.pro_info.tuwen.content;
		// 	console.log(res);
		// 	this.bannerList.forEach( i=> {i.type = "step"});
		// 	this.bannerList.push({type: "feedback"});
		// 	this.$forceUpdate();
		// },

  }
}
</script>
<style lang="stylus">
@import "./tuwen-pc.styl"
@import "./tuwen-mobile.styl"
</style>

